export const getFileStatus = (fileStatus) => {
  switch (fileStatus) {
    case '-1':
      return 'New Login';
    case '0':
      return 'Unassigned';
    case '1':
      return 'Assigned';
    case '2':
      return 'In Progress';
    case '3':
      return 'Hold';
    case '4':
      return 'Reject';
    case '5':
      return 'Completed';
    case '6':
      return 'To be Verify';
    case '7':
      return 'Query Raised';
    case '8':
      return 'Query Received';
    case '9':
      return 'Rectification';
    case '10':
      return 'Hold Query Raised';
    case '11':
      return 'Signature Completed';
    case '12':
      return 'Double Verification Pending';
    case '13':
      return 'Double Verification Inprogress';
    case '14':
      return 'Verification Inprogress';
    case '15':
      return 'Final Approval Pending';
    case '16':
      return 'Final Approval Inprogress';
    case '17':
      return 'Final Approval Hold';
    default:
      return '';
  }
};

export const getVettingFileStatus = (fileStatus) => {
  switch (fileStatus) {
    case '-1':
      return 'New Login';
    case '0':
      return 'Unassigned';
    case '1':
      return 'Assigned';
    case '2':
      return 'Completed';
    case '3':
      return 'Signature Completed';
    case '4':
      return 'Hold';
    case '5':
      return 'UnHold';
    default:
      return '';
  }
};
